export default "__VITE_ASSET__330b1327__"